<template>
  <vx-card>
    <h4 class="mb-2">Application</h4>
    <p class="my-5">You can view your student's job experience application below.</p>

    <template v-if="prework.application_type == 1">
      <h5 class="mb-5">Application Letter</h5>
      <p class="mb-5">Student has applied with application letter.</p>

      <form id="form">
        <p class="mb-1 text-right">{{ prework.application_letter.name }}</p>
        <p class="mb-1 text-right">{{ prework.application_letter.street }}</p>
        <p class="mb-1 text-right">
          {{ prework.application_letter.town }}, {{ prework.application_letter.state }},
          {{ prework.application_letter.postcode }}
        </p>
        <p class="mb-1 text-right">{{ prework.application_letter.phone }}</p>
        <p class="mb-1 text-right">{{ prework.application_letter.email }}</p>
        <p class="mb-5 text-right">Date {{ prework.application_letter.date }}</p>

        <p class="mb-5" style="white-space: pre-line">{{ prework.application_letter.recipient }}</p>

        <p class="mb-5">Dear {{ prework.application_letter.addressed_to }},</p>

        <p class="mb-8" style="white-space: pre-line">
          {{ prework.application_letter.letter_body }}
        </p>

        <p class="mb-1">Yours sincerely,</p>
        <p class="mb-1">{{ prework.application_letter.signature }}</p>
      </form>
    </template>
    <template v-else-if="prework.application_type == 2">
      <h5 class="mb-5">Application Video</h5>
      <p class="mb-5">Student has applied with video.</p>
      <video-player ref="player" class="media-video-player" :options="videoOptions" v-once />
    </template>
    <template v-else-if="prework.application_type == 3">
      <h5 class="mb-5">School e-Portfolio</h5>
      <p class="mb-5">Student has applied with school e-portfolio.</p>
      <a
        :href="prework.application_url"
        target="_blank"
        class="my-5 mr-5 btn btn-secondary btn-size-medium includedIcon"
      >
        <external-link-icon />
        View e-Portfolio
      </a>
    </template>
    <template v-else>
      <h5 class="mb-5">No Application</h5>
      <p>Student hasn't submitted an application yet.</p>
    </template>

    <router-link
      class="inline-block mt-5 btn btn-secondary btn-size-medium"
      :to="'/teacher/vje/activity/student/' + this.$route.params.id"
    >
      Back
    </router-link>
  </vx-card>
</template>

<script>
import theApi from '@/mixins/theApi';
import store from '@/store/store';
import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
import { ExternalLinkIcon } from 'vue-feather-icons';

export default {
  components: { videoPlayer, ExternalLinkIcon },
  data() {
    return {
      prework: false,
      videoOptions: {
        height: '360',
        fluid: true,
        autoplay: false,
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: { type: 'video/mp4', src: 'http://vjs.zencdn.net/v/oceans.mp4' },
      },
    };
  },
  methods: {
    async loadStudents() {
      theApi.methods.makeCall(true, 'vje_students/student/' + this.$route.params.id, 'get').then(
        (data) => {
          this.prework = data.data.prework;
          if (
            this.prework.application_video &&
            this.prework.application_video != '' &&
            this.prework.application_video != null
          ) {
            this.videoOptions.sources.src = this.prework.application_video;
          }
        },
        () => {},
      );
    },
    showWorkExperience() {
      store.dispatch('popup/showIframePopup', this.prework.workplace_safety_url);
    },
  },
  mounted() {
    this.loadStudents();
  },
};
</script>
